import {TZDate} from '@date-fns/tz';
import {format} from 'date-fns';

const TIMEZONE_STORAGE_KEY = 'userTimezone';
export const DEFAULT_TIMEZONE = 'UTC';

export const getStoredTimezone = (): string => {
  try {
    return localStorage.getItem(TIMEZONE_STORAGE_KEY) ?? DEFAULT_TIMEZONE;
  } catch {
    return DEFAULT_TIMEZONE;
  }
};

export const saveTimezone = (tz: string): void => {
  try {
    localStorage.setItem(TIMEZONE_STORAGE_KEY, tz);
  } catch {
    // ignore
  }
};

export const formatInTz = (
  date: Date,
  formatStr: string,
  tz: string = getStoredTimezone(),
): string => format(new TZDate(date, tz), formatStr);

/**
 * Converts a "wall clock" Date (e.g. from a day/time picker) to UTC,
 * treating those wall clock values as being in the given timezone.
 */
export const toUtcFromTz = (
  date: Date,
  tz: string = getStoredTimezone(),
): Date =>
  new Date(
    TZDate.tz(
      tz,
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      date.getHours(),
      date.getMinutes(),
      date.getSeconds(),
    ).getTime(),
  );

/**
 * Converts a UTC Date to a "wall clock" Date in the given timezone,
 * so date pickers display the correct local time.
 */
export const toPickerDateInTz = (
  date: Date,
  tz: string = getStoredTimezone(),
): Date => {
  const tzDate = new TZDate(date, tz);
  return new Date(
    tzDate.getFullYear(),
    tzDate.getMonth(),
    tzDate.getDate(),
    tzDate.getHours(),
    tzDate.getMinutes(),
    tzDate.getSeconds(),
  );
};

export const TIMEZONES = Intl.supportedValuesOf('timeZone');
